
import { Logo } from "../svg/Logo";
import { useNavigate } from "react-router-dom"; // useNavigateをインポート
const Header = () => {
  const navigate = useNavigate()

  const logoutHandler = () => {
    sessionStorage.removeItem("jacUserCore");
    navigate('/')
  }

  return (
    <header style={{ textAlign: `center`, position: `relative` }}>
      <h1><Logo /></h1>
      <button className="logout" onClick={logoutHandler}>LOG OUT</button>
    </header>
  )
}
export default Header;
